export const enum ContainersNames {
    FREE_SPINS_WRAPPER = 'FREE SPINS WRAPPER',
    REELS_WRAPPER = 'REELS WRAPPER',
    SLOT_PANELS_WRAPPER = 'SLOT_PANELS_WRAPPER',
    GAME_CONTAINER = 'GAME_CONTAINER',
    BACKGROUND_CONTAINER = 'BACKGROUND_CONTAINER',
    BOTTOM_UNMASKED_CONTAINER = 'BOTTOM_UNMASKED_CONTAINER',
    REELS_CONTAINER = 'REELS_CONTAINER',
    TOP_UNMASKED_CONTAINER = 'TOP_UNMASKED_CONTAINER',
    CROP_MASK = 'CROP_MASK',
    ANIMATION_WRAPPER = 'ANIMATION_WRAPPER',
    LOGO_CONTAINER = 'LOGO_CONTAINER',
    INTRO_ANIMATION_CONTAINER = 'INTRO_ANIMATION_CONTAINER',
    SPLASH_SCREEN_CONTAINER = 'SPLASH_SCREEN_CONTAINER',
    BUY_BONUS_CONTAINER = 'BUY_BONUS_CONTAINER',
    FREE_SPINS_POPUPS_CONTAINER = 'FREE_SPINS_POPUPS_CONTAINER',
    FREE_SPINS_SUMMARY_POPUPS_CONTAINER = 'FREE_SPINS_SUMMARY_POPUPS_CONTAINER',
    POPUPS_TRANSITION_CONTAINER = 'POPUPS_TRANSITION_CONTAINER',
}
